<script>
import Page from '@/views/admin/SinglePage';
import VStatusBadge from '@/components/v3/elements/VStatusBadge';
import { mapGetters } from 'vuex';

/**
 *
 * @version 1.0.0
 * @since
 */
export default {
  name: 'Index',
  components: {
    Page,
    VStatusBadge,
  },
  computed: {
    ...mapGetters('entities/users', ['isVenueHubDocConnected']),
    venueId() {
      return this.$route.params.id;
    },
    isHubDocConnected() {
      return this.isVenueHubDocConnected(this.venueId);
    },
  },
};
</script>

<template>
  <page>
    <template #breadcrumbs>
      <router-link :to="{ name: 'venue-settings-integrations' }">
        <font-awesome-icon icon="arrow-left" />
        Back to {{ $t('global.venue') }} Settings
      </router-link>
    </template>
    <template #title>
      <div class="u-flex-center logo">
        <img src="@/assets/logo-hubdoc.svg" width="32" height="32" alt="HubDoc Logo" />
        <h2 class="m-0 ml-8 hub-doc-title">{{ $t('hubDoc.name') }}</h2>
        <v-status-badge type="green" v-if="isHubDocConnected">Connected</v-status-badge>
        <v-status-badge type="gray" v-else>Not Connected</v-status-badge>
      </div>
    </template>

    <template #navigation>
      <ul>
        <li>
          <router-link :to="{ name: 'venue-hub-doc-account' }"> Account Info </router-link>
        </li>
      </ul>
    </template>
  </page>
</template>

<style lang="scss" scoped>
.logo {
  .hub-doc-title {
    @include font-size(24px);
    font-weight: 500;
  }
  img {
    border-radius: 50%;
    border: 1px solid #e1e5ed;
  }
}
</style>
